import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Card from './Card';
import { Chevron } from './UiIcons';
import {
  ssColorCyan,
  ssColorDarkGrey,
  mediaBreakpointUpLG,
} from '../constants/style-constants';

const SmallChevron = styled(Chevron)`
  width: 20px;
  height: 20px;
  margin: 0 0.5rem 0 1rem;
  transition: transform 0.25s;

  g {
    stroke: ${ssColorCyan};
    transition: stroke 0.25s;
  }
`;

const DashboardCardCSS = css`
  position: relative;
  padding-right: 4rem;
  background-color: ${ssColorDarkGrey};

  ${mediaBreakpointUpLG} {
    padding-right: 5rem;
  }

  .icon-chevron {
    position: absolute;
    top: 50%;
    right: 2rem;
    margin: 0;
    transform: translate(0, -50%);
  }

  &:hover {
    .icon-chevron {
      transform: translate(6px, -50%);
    }
  }
`;

const DashboardCard = ({
  href, children, showIcon, extraCss,
}) => (
  <Card href={href} css={[DashboardCardCSS, ...extraCss]}>
    {children}
    {showIcon && <SmallChevron />}
  </Card>
);

DashboardCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  href: PropTypes.string,
  showIcon: PropTypes.bool,
  extraCss: PropTypes.arrayOf(PropTypes.object),
};

DashboardCard.defaultProps = {
  href: null,
  children: null,
  showIcon: true,
  extraCss: [],
};

export default DashboardCard;
